import { Component, forwardRef } from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from "@angular/forms";
import { SelectModule } from "primeng/select";
import { countriesList } from "../../../utils/constants/countries.constant";

type Country = (typeof countriesList)[number];

@Component({
  selector: "app-ddi-select",
  templateUrl: "./ddi-select.component.html",
  styleUrl: "./ddi-select.component.scss",
  imports: [ReactiveFormsModule, SelectModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DdiSelectComponent),
      multi: true,
    },
  ],
})
export class DdiSelectComponent implements ControlValueAccessor {
  readonly ddiList = [...countriesList].sort((a, b) =>
    a.name.localeCompare(b.name, "pt-BR"),
  );
  readonly country = new FormControl<Country | null>(
    this.ddiList.find((item) => item.acronym === "BR") ?? null,
  );
  readonly panelStyle = {
    width: "min(320px, calc(100vw - 32px))",
    minWidth: "0",
    overflow: "hidden",
  };
  private onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value: string | null): void {
    const selectedCountry = this.ddiList.find(
      (country) => country.code === value,
    );
    if (selectedCountry) {
      this.country.setValue(selectedCountry, { emitEvent: false });
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    if (disabled) {
      this.country.disable({ emitEvent: false });
    } else {
      this.country.enable({ emitEvent: false });
    }
  }

  selectOption(country: Country): void {
    if (this.country.disabled || !country) return;
    this.onChange(country.code);
    this.onTouched();
  }
}
